var _defs, _metadata, _rect, _g, _path, _g2, _path2, _g3, _circle, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1400 1133",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:31.9593}\r\n    .str2 {stroke:black;stroke-width:31.9593;stroke-linecap:round}\r\n    .str1 {stroke:black;stroke-width:31.9593;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil2 {fill:black}\r\n    .fil1 {fill:#999999}\r\n    .fil3 {fill:white}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166 739c-34,99 -38,169 -10,174 79,13 284,-41 379,6 72,36 78,61 165,61 87,0 93,-25 165,-61 95,-47 299,7 378,-6 29,-5 24,-75 -9,-174 -82,-243 -241,-532 -534,-527 -270,-4 -458,302 -534,527z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_211448656"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1400,
    height: 1133
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M278 507c0,0 -59,-133 -77,-233 -14,-77 11,-124 18,-135 9,-13 73,-6 135,27 61,32 120,91 137,109l-213 232z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1122 507c0,0 59,-133 77,-233 14,-77 -11,-124 -18,-135 -9,-13 -73,-6 -135,27 -61,32 -120,91 -138,109l214 232z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M324 426l102 -115c0,0 -100,-79 -136,-74 -35,6 9,129 34,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1076 426l-102 -115c0,0 99,-79 135,-74 36,6 -8,129 -33,189z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M166 739c-34,99 -38,169 -10,174 79,13 284,-41 379,6 72,36 78,61 165,61 87,0 93,-25 165,-61 95,-47 299,7 378,-6 29,-5 24,-75 -9,-174 -82,-243 -241,-532 -534,-527 -270,-4 -458,302 -534,527z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M92 932c0,0 181,-420 387,-423 113,-2 140,102 146,139 14,79 -47,148 -47,148l-100 129 -386 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M228 932c0,0 135,-385 289,-388 84,-2 104,93 109,128 10,72 -36,135 -36,135l-74 119 -288 6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil3",
    cx: 507,
    cy: 692,
    rx: 78,
    ry: 85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 529,
    cy: 693,
    r: 71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1308 932c0,0 -181,-420 -387,-423 -113,-2 -140,102 -146,139 -14,79 47,148 47,148l100 129 386 7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1172 932c0,0 -135,-385 -289,-388 -84,-2 -104,93 -109,128 -10,72 36,135 36,135l74 119 288 6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil3",
    cx: 893,
    cy: 692,
    rx: 78,
    ry: 85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 871,
    cy: 693,
    r: 71
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil3",
    cx: 700,
    cy: 873,
    rx: 201,
    ry: 109
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M166 739c-34,99 -38,169 -10,174 79,13 284,-41 379,6 72,36 78,61 165,61 87,0 93,-25 165,-61 95,-47 299,7 378,-6 29,-5 24,-75 -9,-174 -82,-243 -241,-532 -534,-527 -270,-4 -458,302 -534,527z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "fil3",
    cx: 850,
    cy: 691,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil3",
    cx: 549,
    cy: 691,
    r: 28
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 709,
    cy: 829,
    r: 51
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M708 829c0,23 2,46 0,69 -2,34 -77,39 -81,-22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M709 829c0,23 -2,46 0,69 2,34 77,39 81,-22"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni5);
export default __webpack_public_path__ + "static/media/ani5.605ac4c3f7b8dfd2c6f6f3b407d1a454.svg";
export { ForwardRef as ReactComponent };